// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3FNcE","header":"PatientBlock_header__3KSEZ","label":"PatientBlock_label__22Cfh","option":"PatientBlock_option__1L4Yf"};